/**
 * Generates json+ld compatible breadcrumb schema for SEO
 *
 * @export
 * @param {*} path The current path
 * @param {*} title The current page title
 * @returns {Object}
 */
export function getBreadcrumbSchema (path, title) {
  const baseUrl = 'https://attentionarchitects.com'
  const segments = path.split('/').filter(segment => !!segment)
  let url = ''
  if (segments[0] === 'nl') {
    url += '/' + segments.splice(0, 1)
  }

  return {
    hid: 'breadcrumbs',
    innerHTML: JSON.stringify({
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      'itemListElement': [{
        '@type': 'ListItem',
        'position': 1,
        'item': {
          '@id': baseUrl + url,
          'name': 'Attention Architects'
        }
      }, {
        '@type': 'ListItem',
        'position': 2,
        'item': {
          '@id': baseUrl + url + '/' + segments[0],
          'name': title
        }
      }]
    }),
    type: 'application/ld+json',
    body: true
  }
}

/**
 * Tries to parse the first argument as a date, and uses the
 * second argument if this first attempt fails.
 * 
 * @export
 * @param {String|Date|int} one Date instance to test for
 * @param {String|Date|int} two Fallback date
 * @returns {Date}
 */
export function fallbackDate(one, two) {
  // Check if publication date is set in the document.
  // Otherwise just show the creation moment.
  let pubDate = Date.parse(one)
  if (isNaN(pubDate) === false) {
    return new Date(pubDate)
  } else {
    return new Date(two)
  }
}